import { AnyAction } from "redux";
import { RepairStore } from "../../interfaces";
import { RepairTypes } from "../types";

const initialState: RepairStore = {
    repairs: [],
    meta: {
        itemCount: 0,
        page: 1,
        take: 25,
        pageCount: 0,
        hasPreviousPage: false,
        hasNextPage: false,
    },
    filters: {
        status: "",
        search: "",
        page: 1,
        take: 25,
    },
    loading: false,
    success: false,
    selectedRepair: null,
};

export const repairReducer = (state = initialState, action: any): RepairStore => {
    switch (action.type) {
        case RepairTypes.GET_REPAIR_BY_ID_LOADING:
            return {
                ...state,
                loading: action.payload.loading,
            };
        case RepairTypes.GET_REPAIR_BY_ID_SUCCESS:
            return {
                ...state,
                selectedRepair: action.payload.selectedRepair,
                loading: action.payload.loading,
                success: action.payload.success,
            };
        case RepairTypes.GET_REPAIR_BY_ID_FAILURE:
            return {
                ...state,
                loading: action.payload.loading,
                success: action.payload.success,
            };
        case RepairTypes.GET_REPAIRS_LOADING:
            return {
                ...state,
                loading: action.payload.loading,
            };
        case RepairTypes.GET_REPAIRS_SUCCESS:
            return {
                ...state,
                repairs: action.payload.repairs,
                meta: action.payload.meta,
                filters: action.payload.filters,
                loading: action.payload.loading,
                success: action.payload.success,
            };
        case RepairTypes.GET_REPAIRS_FAILURE:
            return {
                ...state,
                loading: action.payload.loading,
                success: action.payload.success,
            };
        case RepairTypes.SET_REPAIR_FILTER_STATUS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload.filters,
                },
            };
        case RepairTypes.SET_REPAIR_FILTER_SEARCH:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload.filters,
                },
            };
        case RepairTypes.UPDATE_REPAIR_LOADING:
            return {
                ...state,
                loading: action.payload.loading,
            };
        case RepairTypes.UPDATE_REPAIR_SUCCESS:
            return {
                ...state,
                repairs: action.payload.repairs !== undefined ? action.payload.repairs : state.repairs,
                loading: action.payload.loading,
                success: action.payload.success,
            };
        case RepairTypes.UPDATE_REPAIR_FAILURE:
            return {
                ...state,
                loading: action.payload.loading,
                success: action.payload.success,
            };
        default:
            return state;
    }
}; 